export default __webpack_public_path__ + "static/Plots0013-42b8fd2d7096af06403d2432aca5e2ca.jpg";